import React, { useState, useEffect, useCallback } from 'react';
import { talukaAPI } from '../../services/api';

export default function TalukaBusinesses() {
  const [items, setItems]   = useState([]);
  const [gps, setGps]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);
  const [page, setPage]     = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ tenant_id: '', type: '', search: '' });

  const load = useCallback(async () => {
    try {
      setLoading(true); setError(null);
      const [bRes, gRes] = await Promise.all([
        talukaAPI.getBusinesses({ page, limit: 20, ...filters }),
        gps.length === 0 ? talukaAPI.getGrampanchayats() : Promise.resolve({ data: { grampanchayats: gps } })
      ]);
      const d = bRes.data?.businesses || bRes.data?.data || bRes.data || {};
      setItems(Array.isArray(d) ? d : []);
      setTotalPages(bRes.data?.pagination?.totalPages || Math.ceil((bRes.data?.pagination?.total || 1) / 20) || 1);
      if (gps.length === 0) setGps(gRes.data?.grampanchayats || gRes.data?.data || gRes.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load businesses');
    } finally { setLoading(false); }
  }, [page, filters]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);
  const setF = (key, val) => { setFilters(f => ({ ...f, [key]: val })); setPage(1); };

  return (
    <div>
      <div className="tk-page-header">
        <h1>Business Registrations</h1>
        <p>Registered businesses across all Grampanchayats</p>
      </div>
      <div className="tk-filter-bar">
        <input placeholder="Search business name…" value={filters.search} onChange={e => setF('search', e.target.value)} />
        <select value={filters.tenant_id} onChange={e => setF('tenant_id', e.target.value)}>
          <option value="">All GPs</option>
          {gps.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
        <input placeholder="Business type…" value={filters.type} onChange={e => setF('type', e.target.value)} />
      </div>
      {loading && <div style={{ textAlign: 'center', padding: 40 }}>Loading…</div>}
      {error   && <div style={{ textAlign: 'center', padding: 40, color: '#c62828' }}>{error}</div>}
      {!loading && !error && (
        <>
          <div className="tk-card">
            <div className="tk-table-wrap">
              <table className="tk-table">
                <thead>
                  <tr><th>Business Name</th><th>Type</th><th>Owner</th><th>Mobile</th><th>Grampanchayat</th><th>Status</th><th>Registered</th></tr>
                </thead>
                <tbody>
                  {items.map((b, i) => (
                    <tr key={b.id || i}>
                      <td><strong>{b.business_name || b.name}</strong></td>
                      <td style={{ textTransform: 'capitalize' }}>{(b.business_type || b.type || '—').replace('_', ' ')}</td>
                      <td>{b.owner_name || '—'}</td>
                      <td>{b.mobile_number || b.phone || '—'}</td>
                      <td>{b.gp_name || b.Tenant?.name || '—'}</td>
                      <td><span className={`tk-badge ${b.is_active ? 'tk-badge-active' : 'tk-badge-inactive'}`}>{b.is_active ? 'Active' : 'Inactive'}</span></td>
                      <td style={{ whiteSpace: 'nowrap' }}>{b.createdAt ? new Date(b.createdAt).toLocaleDateString('en-IN') : '—'}</td>
                    </tr>
                  ))}
                  {items.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>No businesses found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
          <div className="tk-pagination">
            <button onClick={() => setPage(p => p - 1)} disabled={page <= 1}>← Prev</button>
            <span style={{ fontSize: '0.85rem', color: '#555' }}>Page {page} of {totalPages}</span>
            <button onClick={() => setPage(p => p + 1)} disabled={page >= totalPages}>Next →</button>
          </div>
        </>
      )}
    </div>
  );
}
